import React from "react";
import { Tabs, Button, Modal, Input, Icon } from "antd";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import s from "./Timetable.module.scss";

// Asssets
import diogo from "../imgs/diogo.jpg";

const _emptyBooking = {
  time: "",
  date: "",
  class: "",
  course_id: 0,
};

class Timetable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      days: [
        moment(),
        moment(),
        moment(),
        moment(),
        moment(),
        moment(),
        moment(),
      ],
      calendar: [],
      labels: {},
      booking: _emptyBooking,
      modalBooking: false,
      modalNotyet: false,
      modalFull: false,
      modalNotice: false,
      name: "",
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    axios({
      method: "GET",
      // url: `https://rga.cromasome.com/api/courses/calendar`,
      url: `http://144.76.199.153:4004/api/bookings/v1/calendar`,
      headers: {
        "Content-Type": "application/json",
      },
      json: true,
    })
      .then((response) => {
        this.setState({ loading: false, calendar: response.data }, () => {
          this.time2grid();
        });
        console.log("response", response.data);
      })
      .catch((err) => {
        console.log("Request Network Error");
      });

    const days = [];
    const labels = {};

    for (var i = 0; i <= 6; i++) {
      const _date = moment().add(i, "days");
      days.push(_date);
      labels[_date.format("dddd")] = i;
    }
    this.setState({ days, labels });
  }

  handleCancel = (_e) => {
    this.setState({
      booking: _emptyBooking,
      name: "",
      saved: false,
      error: false,
      modalBooking: false,
      modalNotAllowed: false,
      modalNotice: false,
    });
  };

  setName = (_e) => {
    this.setState({
      name: _e.target.value,
    });
  };

  setBooking = (_class) => {    
    const _time = _class.time;
    const _className = _class.name;
    const _date = _class.date2;

    // console.log("_className", _className);
    // console.log("_date", _date);
    // console.log("_time", _time);

    if (_class.css_class === "event") {
      this.setState({ modalNotice: true });
    } else {
      this.setState({ loading: true });
      axios({
        method: "POST",
        // url: `https://rga.cromasome.com/api/lectures/allowed`,
        url: `http://144.76.199.153:4004/api/bookings/v1/allowed`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          date: _date,
          time: _time,
          class: _className,
        },
        json: true,
      })
        .then((response) => {
          // console.log("response", response);
          if (response.status === 200) {
            console.log("response.data.success", response.data);
            if (response.data.allowed) {
              this.setState({
                booking: {
                  time: _time,
                  date: _date,
                  class: _className,
                  course_id: _class.id,
                },
                modalBooking: true,
                modalNotAllowed: false,
                msg: null,
                loading: false,
              });
            } else {
              this.setState({
                loading: false,
                modalBooking: false,
                modalNotAllowed: true,
                msg: response.data.msg,
              });
            }
          } else {
            this.setState({
              loading: false,
              modalBooking: false,
              modalNotAllowed: true,
              msg: response.data.msg,
            });
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
            modalBooking: false,
            modalNotAllowed: true,
            msg: "Server Error. Try later",
          });
        });
    }
  };

  makeBooking = (_e) => {
    if (this.state.name !== "") {
      const _data = {
        time: this.state.booking.time,
        date: this.state.booking.date,
        class: this.state.booking.class,
        name: this.state.name,
        course_id: this.state.booking.course_id,
      };

      this.setState({ loading: true });

      axios({
        method: "POST",
        // url: `https://rga.cromasome.com/api/lectures/index`,
        url: `http://144.76.199.153:4004/api/bookings/v1/lecture`,
        headers: {
          "Content-Type": "application/json",
        },
        data: _data,
        json: true,
      })
        .then((response) => {
          // console.log("response", response);
          if (response.status === 200) {
            if (response.data.success) {
              console.log("response ~ ~ ~ ~ ~ >>", response);
              this.setState({ saved: true, error: false, loading: false });
            }
          } else {
            this.setState({ saved: false, error: true, loading: false });
          }
        })
        .catch((err) => {
          this.setState({ saved: false, error: true, loading: false });
        });
    }
  };

  time2grid = (_beginHour = 8, _endHour = 22) => {
    const __endHour = _endHour + 1;
    const _slots = (__endHour - _beginHour) * 2;

    const a = (_slots - 1) / (_endHour - _beginHour);
    const b = 1 - _beginHour * a;

    const _calendar = this.state.calendar;

    _calendar.map((_day, _i) => {
      // Set Grid Spans
      _day.classes.map((_class, _c) => {
        const _p = _class.time.split(":");
        let x;
        switch (_p[1]) {
          case "00":
            x = parseFloat(_p[0]);
            break;
          case "15":
            x = parseFloat(_p[0]);
            _calendar[_i].classes[_c].gridOffset = true;
            break;
          case "30":
            x = parseFloat(_p[0]) + 0.5;
            break;
          case "45":
            x = parseFloat(_p[0]) + 0.5;
            _calendar[_i].classes[_c].gridOffset = true;
            break;
          default:
            x = parseFloat(_p[0]);
            break;
        }

        const y = Math.floor(a * x + b);

        _calendar[_i].classes[_c].gridRow = y;

        // Set Date
        this.state.days.map((_dayDate) => {
          if (_dayDate.format("dddd") === _day.day) {
            const _date = moment(
              `${_dayDate.format("YYYY-MM-DD")} ${_class.time}`
            );
            const _date2 = _dayDate.format("YYYY-MM-DD");
            // _calendar[_i].classes[_c].date = _date;
            _calendar[_i].classes[_c].date2 = _date2;
            _calendar[_i].classes[_c].dayDate = _dayDate;
          }
        });
      });
    });

    this.setState({ calendar: _calendar });
  };

  render() {
    const _hours = [];
    for (let h = 8; h < 22; h++) {
      _hours.push(`${_.padStart(h, 2, "0")}:00`);
      _hours.push(`${_.padStart(h, 2, "0")}:30`);
    }
    // _hours.pop();
    _hours.shift();

    return (
      <>
        <h1 className="heading" style={{ color: "#f00", fontSize: 30 }}>
          Booking Schedule for Registered Active Members Only.
        </h1>
        <div className="heading">
          <a href="/timetable.pdf" download>
            <h3 style={{ color: "#01A3D6" }}>Download current timetable</h3>
          </a>
        </div>

        <div className={s.wrapper}>
          {this.state.loading ? (
            <div className={s.loadingScreen}>
              <Icon type="loading" style={{ fontSize: 56, color: "#fff" }} />
            </div>
          ) : null}

          <div className={s.container}>
            <div className={s.title}>{moment().format("MMMM YYYY")}</div>
            <div className={s.days}>
              <div className={s.filler}></div>
              <div className={s.filler}></div>
              {this.state.days.map((_day, _i) => (
                <div key={_i} className={s.day}>
                  {_day.format("ddd Do")}
                </div>
              ))}
            </div>
            <div className={s.content}>
              {_hours.map((_slot, _i) => (
                <div
                  key={_i}
                  className={s.time}
                  style={{ gridRow: parseInt(_i + 1) }}
                >
                  {_slot}
                </div>
              ))}

              <div className={s.fillercol}></div>

              {this.state.days.map((_day, _i) => (
                <div
                  key={_i}
                  className={`${s.col} ${
                    _day.day() === 0 || _day.day() === 6 ? s.weekend : ""
                  }`}
                  style={{ gridColumn: parseInt(_i + 3) }}
                ></div>
              ))}

              {_hours.map((_slot, _i) => (
                <div
                  key={_i}
                  className={s.row}
                  style={{ gridRow: parseInt(_i + 1) }}
                ></div>
              ))}

              <div className={s.currentTime}>
                <div className={s.circle}></div>
              </div>

              {this.state.calendar.map((_day, _i) =>
                _day.classes.map((_class, _c) => (
                  <div
                    key={`${_i}${_c}`}
                    onClick={() => this.setBooking(_class)}
                    className={`${s.class} ${s[_class.css_class]} ${
                      _class.gridOffset ? s.offset : ""
                    } ${s["duration" + _class.duration]}`}
                    style={{
                      gridColumn: parseInt(this.state.labels[_day.day] + 3),
                      gridRow: `${_class.gridRow}`,
                    }}
                  >
                    {_class.name}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <Modal
          title="Book a class"
          visible={this.state.modalBooking}
          onOk={this.state.saved ? this.handleCancel : this.makeBooking}
          onCancel={this.handleCancel}
          okText={
            this.state.loading ? (
              <Icon type="loading"></Icon>
            ) : (
              `${this.state.saved ? "Close" : "Book Class"}`
            )
          }
          okButtonProps={{
            disabled: this.state.name === "" ? true : false,
          }}
        >
          <>
            {this.state.saved ? (
              <>
                <h1 style={{ color: "#6F9C79" }}>
                  OSS !, {this.state.booking.class} Booked
                </h1>
                {["BJJ White Belts", "BJJ", "BJJ Fundamentals"].includes(
                  this.state.booking.class
                ) ? (
                  <h2>
                    At this class, members should wear the Oficial Team GI 🥋
                  </h2>
                ) : null}
                <br />
                <h2>
                  {this.state.name}, see you <br />
                  {moment(this.state.booking.date).format("dddd Do MMMM")}{" "}
                  {this.state.booking.time} <br />
                </h2>
              </>
            ) : (
              <>
                <h1>{this.state.booking.class}</h1>
                {/*
                <h1 className="heading" style={{ color: "#f00" }}>
                  Achtung: Es gilt 2G!
                </h1>
                <p>
                  Die Teilnahme am Training ist ausschließlich für Geimpfte und Genese gestattet. Ich bestätige mit meiner Anmeldung, dass ich entweder geimpft oder genesen bin. <br/>
                  Sollte ich am Training teilnehmen, ohne geimpft oder genesen zu sein, hafte ich für allfällige Schäden, welche ONETO Brasilianische Jiu-Jitsu Selbstverteidigung und Kampfkunstverein (Roger Gracie Vienna) und seine Organen dadurch erleiden und tragen müssen.<br/>
                  OSS!
                </p>
                */}
                <h2>
                  Date:
                  {/* this.state.booking.date.format("dddd Do MMMM") */}{" "}
                  {moment(this.state.booking.date).format("dddd Do MMMM")}{" "}
                  {this.state.booking.time}
                </h2>
                <br />
                <label>Your Name:</label>
                <div className={`${this.state.name === "" ? "has-error" : ""}`}>
                  <Input
                    onChange={this.setName}
                    size="large"
                    value={this.state.name}
                  />
                </div>
              </>
            )}
          </>
        </Modal>
        <Modal
          title="Booking not Allowed"
          visible={this.state.modalNotAllowed}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          okText={null}
        >
          <div>
            <h1 style={{ color: "#FA4018" }}>{this.state.msg}</h1>
          </div>
        </Modal>
        <Modal
          title="Open Mat"
          visible={this.state.modalNotice}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          okText={null}
        >
          <div>
            <h1>Open Mat</h1>            
          </div>
        </Modal>
        {/*
        <Modal
          title="Seminar Diogo Primo"
          visible={this.state.modalNotice}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          okText={null}
        >
          <div>
            <h1>Seminar Diogo Primo</h1>
            <p>Cost and Registration with Orlando beforehand in Gym</p>
            <img style={{ width: "100%" }} className="imgFit" src={diogo}></img>
          </div>
        </Modal>
        */}
      </>
    );
  }
}

export default Timetable;
